import { LANGUAGES } from "@/constants/languages";

export function isSupportedLanguage(language: string): boolean {
  return LANGUAGES.some(({ value }) => value === language);
}
